import { createApp } from 'vue'
import '@mdi/font/css/materialdesignicons.css'
// Vuetify
import vuetify from './plugins/vuetify'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
 
createApp(App).use(vuetify).use(store).use(router).mount('#app')
